require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-top-5-podcasts-for-ios-developers.json") })
        }
      }, "path---blog-top-5-podcasts-for-ios-developers");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-top-5-podcasts-for-ios-developers!./.cache/json/blog-top-5-podcasts-for-ios-developers.json
// module id = 1116
// module chunks = 231608221292675